<template>
  <md-dialog :md-active="isVisible" :md-backdrop="true">
    <md-dialog-title>Add New Member</md-dialog-title>

    <md-dialog-content>
      <!-- Email -->
      <md-field>
        <label>Email</label>
        <md-input v-model="email" type="email" :multiple="true"></md-input>
      </md-field>

      <!-- Phone -->
      <md-field>
        <label>Phone Number</label>
        <md-input v-model="phone" type="number"></md-input>
      </md-field>

      <!-- Roles -->
      <md-field>
        <label for="roles">Roles</label>
        <md-select v-model="roles" id="roles">
          <md-option
            :value="role"
            v-for="(role, index) in validRoles"
            :key="index"
            >{{ role }}
          </md-option>
        </md-select>
      </md-field>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="confirm()">Add</md-button>
      <md-button class="md-accent" @click="close()">Close</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<style scoped></style>

<script>
import { validRoles } from '../../../utils/Role.util';

export default {
  name: 'add-to-business-modal',
  props: ['createBusinessAccess'],
  data() {
    return {
      isVisible: false,
      email: '',
      phone: '',
      roles: '',
      validRoles,
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },
    async confirm() {
      const form = { phone: this.phone, email: this.email, roles: this.roles };
      await this.createBusinessAccess(form);
      this.email = '';
      this.phone = '';
      this.roles = '';
    },
  },
};
</script>

<style scoped>
.md-menu-content {
  z-index: 11 !important;
}
</style>
